<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/5iTPmy/tc-custom/9780547525365.jpg?1712288212261" alt="This image is the cover for the book Jump-Off Creek"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Jump-Off Creek
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A widowed homesteader is determined to make a life in the unforgiving mountains of late 19th century Oregon in this “powerful novel of struggle and loss” (<i>Dallas morning News</i>).</b></p><p>Acclaimed author Molly Gloss drew on pioneer diaries and old family stories to write this modern Western classic of a solitary woman’s frontier life. In the 1890s, Lydia Sanderson leaves her old life behind and journey’s to Jump-Off Creek to make her way as a homesteader. Enduring the hardships and deprivations of Oregon’s high mountain country, Lydia finds both courage and community in her determination to survive.</p> This “unsparing portrait of pioneer life, recounted simply and without romanticism” displays an “intimate understanding of the harsh physical conditions” of the Western frontier, as well as the methods and practices that made such conditions livable (<i>Publishers Weekly</i>).
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Molly Gloss
      </h2>
      
      <p class="authorDescription body article">MOLLY GLOSS is the best-selling author The Hearts of Horses, The Jump-Off Creek, winner of both the Pacific Northwest Booksellers Award and the Oregon Book Award,  The Dazzle of Day, winner of  the PEN Center West Fiction Prize, and Wild Life, winner of the James Tiptree Jr. Award.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Houghton Mifflin Harcourt (www.hmhco.com)
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b1bb0122